import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';
import { clearSbemCustomContentCache } from '../../services/AssetService';
import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class PagesCustomization extends Component {
    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    onUploadSuccess = () => {
        const { chainId, hotelId } = this.props;
        clearSbemCustomContentCache(chainId, hotelId);
    };

    render() {
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Customization files</h1>
                <hr />
                {this.props.children}
                <AssetBrowser
                    setRef={node => (this.browser = node)}
                    category={CATEGORIES.CUSTOMIZATION}
                    filter=".+\.(js|css|html)"
                    displayMode="grid"
                    hasAccessForDelete={this.props.hasAccessCustomContent.delete}
                >
                    <div className="col-xs-1">
                        <AssetUploader
                            hasAccess={this.props.hasAccessCustomContent.add}
                            filter=".+\.(js|css|html)"
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onSuccess={this.onUploadSuccess}
                            onOpen={this.onResetErrors}
                            metadata={{
                                category: CATEGORIES.CUSTOMIZATION
                            }}
                        />
                    </div>
                </AssetBrowser>
            </div>
        );
    }
}

PagesCustomization.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        accessLevel: state.oauth.accessLevel,
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        hasAccessCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

export default connect(mapStateToProps)(PagesCustomization);



// WEBPACK FOOTER //
// ./src/components/assets/PagesCustomization.js